import angular from 'angular';
import uiRouter from 'angular-ui-router';
import vaccineComponent from './vaccine.component';
import vaccineListComponent from './vaccine-list.component';
import vaccineDetailComponent from './vaccine-detail.component';
import vaccineService from './vaccine.service';

let vaccineModule = angular.module('vaccine', [
  uiRouter
])

.service('Vaccine', vaccineService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/vaccine');

  $stateProvider
    .state('vaccine', {
      component: 'vaccine'
    })
    .state('vaccine.list', {
      url: '/vaccine',
      component: 'vaccineList'
    })
    .state('vaccine.create', {
      url: '/vaccine/new',
      component: 'vaccineDetail',
      params: {
      	id: ""
      }
    })
    .state('vaccine.edit', {
      url: '/vaccine/:id/edit',
      component: 'vaccineDetail',
      params: {
        id: ""
      }
    });
})

.component('vaccine', vaccineComponent)
.component('vaccineList', vaccineListComponent)
.component('vaccineDetail', vaccineDetailComponent)

.name;

export default vaccineModule;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine.js